import Cookies from 'js-cookie'
import Setting from '@/setting'

const cookies = {}

/**
 * @description 存储 cookie 值
 * @param {String} name cookie name
 * @param {String} value cookie value
 * @param {Object} cookieSetting cookie setting
 */
cookies.set = async function (name = 'default', value = '', cookieSetting = {}) {
  const currentCookieSetting = {
    expires: Setting.cookiesExpires
  }
  Object.assign(currentCookieSetting, cookieSetting)
  Cookies.set(`soga-mall-${name}`, value, currentCookieSetting)
}

/**
 * @description 拿到 cookie 值
 * @param {String} name cookie name
 */
cookies.get = function (name = 'default') {
  if (name === 'token' && window && window.HTMLOBJ && window.HTMLOBJ.getToken) {
    const token = window.HTMLOBJ.getToken();
    if (token) { return token; }
  }
  return Cookies.get(`soga-mall-${name}`)
}

/**
 * @description 拿到 cookie 全部的值
 */
cookies.getAll = function () {
  return Cookies.get()
}

/**
 * @description 删除 cookie
 * @param {String} name cookie name
 */
cookies.remove = function (name = 'default') {
  return Cookies.remove(`soga-mall-${name}`)
}

export default cookies
